import { useEffect, useState } from "react";
import ambassadorBg from "assets/images/others/ambassador-side-images/ambassadorBg.png";
import { ReactComponent as Medal } from "assets/images/svgs/ambassador/medal.svg";
import { ReactComponent as Award } from "assets/images/svgs/ambassador/award.svg";
import { ReactComponent as FamilyProfile } from "assets/images/svgs/ambassador/familyprofileimage.svg";
import { ReactComponent as Badge1 } from "assets/images/svgs/ambassador/badges.svg";
import { ReactComponent as Badge2 } from "assets/images/svgs/ambassador/bages2.svg";
import badgesBg from "assets/images/others/host-side-images/badgesBg.png";
import flag from "assets/images/svgs/ambassador/flag.svg";
import { useNavigate } from "react-router-dom";
import FilterDrawer from "components/drawers/host-side/FilterDrawer";
import {
  BAGDE_TYPES,
  EVENT_STATUS,
  EVENT_TIMEFRAMES,
} from "utils/helpers/enums/shared.enum";
import { EventsFilterDTO } from "utils/helpers/models/host-dtos/events-filter.dto";
import PostActivityPopup from "./components/PostActivityPopup";
import { siteRoutes } from "utils/helpers/enums/routes";
import { ReactComponent as EditIcon } from "assets/images/svgs/ambassador/edit.svg";
import { FaFacebookF, FaInstagram, FaX } from "react-icons/fa6";
import useAmbassador from "../useHooks";
import useUtils from "hooks/useUtils";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import useStore from "hooks/useStore";
import DataNotFound from "components/data-not-found";
import { useSelector } from "react-redux";

interface Badge {
  id: number;
  icon: React.ReactNode;
  label: string;
}
const AmbassadorFamilyprofile = () => {
  const [activeTab, setActiveTab] = useState<"activities" | "promotions">(
    "activities"
  );
  const [open, setOpen] = useState(false);
  const [activityData, setActivityData] = useState<any[]>([]);
  const [page, setPageNumber] = useState(0);
  const [promotionsData, setPromotionsData] = useState<any[]>([]);
  const [promotionPage, setPromotionPage] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [filters, setFilters] = useState<EventsFilterDTO>(
    new EventsFilterDTO()
  );
  const [data, setData] = useState<any[]>([]);
  const [hasMoreActivities, setHasMoreActivities] = useState(true);
  const [hasMorePromotions, setHasMorePromotions] = useState(true);
  const size = 10;
  const { getDateTime } = useUtils();
  const navigate = useNavigate();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const { getActivity, getPromotions, getAmbassadorBadges } = useAmbassador();
  const { getUserProfilePic, getMissionStatement } = useStore();
  const userProfilePic = getUserProfilePic();
  const missionStatement = getMissionStatement();
  const handleOpenPopup = () => {
    setOpen(true);
  };
  const handleClosePopup = () => {
    setOpen(false);
  };
  const handleRedeem = () => {
    setOpen(false);
  };
  const onApplyDrawerFilters = (drawerFilters: any) => {
    for (let key in drawerFilters) {
      filters[key] = drawerFilters[key];
    }
  };

  const toggleDrawer = () => {
    setOpen(!open);
  };

  useEffect(() => {
    getActivity(
      setActivityData,
      { page: 0, size },
      false,
      setHasMoreActivities
    );
    getPromotions(
      setPromotionsData,
      { page: 0, size },
      false,
      setHasMorePromotions
    );
  }, []);
  useEffect(() => {
    const params = { badgeType: BAGDE_TYPES?.ACHIEVEMENT };
    getAmbassadorBadges(setData, params);
  }, []);

  const handleShowMore = () => {
    const nextPage = page + 1;
    setPageNumber(nextPage);
    getActivity(
      setActivityData,
      { page: nextPage, size },
      true,
      setHasMoreActivities
    );
  };

  const handleShowMorePromotions = () => {
    const nextPage = promotionPage + 1;
    setPromotionPage(nextPage);
    getPromotions(
      setPromotionsData,
      { page: nextPage, size },
      true,
      setHasMorePromotions
    );
  };

  console.log(promotionsData);

  return (
    <div className="min-h-screen">
      <div className="container mx-auto px-4 md:mt-[-105px]">
        <div className="flex flex-col lg:flex-row items-start gap-4">
          <div className="flex flex-col lg:flex-row md:mt-20 w-full gap-4">
            {/* Left Sidebar */}
            <div className="w-full sm:w-[351px] lg:w-80 xl:w-96 shrink-0">
              <div className="flex flex-col gap-2 ">
                <h1 className="flex justify-between items-center text-blackie text-base sm:text-lg font-medium">
                  Mission Statement
                  <span
                    className="cursor-pointer"
                    onClick={() => navigate(siteRoutes.ambassadorEditProfile)}
                  >
                    <EditIcon className="w-4 h-4 sm:w-5 sm:h-5" />
                  </span>
                </h1>
                <p className="text-xs sm:text-sm text-blackie">
                  {missionStatement}
                </p>
              </div>
              {data.length > 0 && (
                <div>
                  <div className="mt-6 flex flex-col gap-4 bg-white rounded-xl w-full">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4 py-5 w-full">
                      {data?.map((badge, index) => (
                        <div
                          key={index}
                          className={`relative flex flex-col items-center justify-center p-6 cursor-pointer border rounded-[8px] w-full`}
                        >
                          <img
                            className="w-[80px] sm:w-[98px] min-h-[90px] sm:min-h-[108px] object-cover transition-transform duration-200 hover:scale-105"
                            src={concatPathWithBackendUrl(badge.image.name)}
                          />
                          <span className="text-sm sm:text-lg font-semibold mt-3 text-black capitalize text-center">
                            {badge.name}
                          </span>
                        </div>
                      ))}
                    </div>

                    {data.length > 2 && (
                      <div
                        className="flex justify-center cursor-pointer bg-fade shadow-sm rounded-full p-4"
                        onClick={() => navigate(siteRoutes.ambassadorMyBadges)}
                      >
                        <button className="text-xs text-ambassadorBlue ">
                          See All
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="mt-10">
                    <DataNotFound show={!isLoading && !data.length} />
                  </div>
                </div>
              )}
            </div>

            {/* Activity Feed */}
            <div className="flex-1 w-full space-y-4">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-4">
                {/* Left Side - Activities and Promotions */}
                <div className="flex gap-2">
                  <button
                    className={`px-3 sm:px-4 py-2 rounded-lg font-medium text-sm sm:text-base ${
                      activeTab === "activities"
                        ? "bg-tabsBlueBg text-white"
                        : "bg-[#F9F9F9] text-[#A5A5A5]"
                    }`}
                    onClick={() => setActiveTab("activities")}
                  >
                    Activities
                  </button>
                  <button
                    className={`px-3 sm:px-4 py-2 rounded-lg font-medium text-sm sm:text-base ${
                      activeTab === "promotions"
                        ? "bg-tabsBlueBg text-white"
                        : "bg-[#F9F9F9] text-[#A5A5A5]"
                    }`}
                    onClick={() => setActiveTab("promotions")}
                  >
                    Promotions
                  </button>
                </div>

                {/* Right Side - Filter and Post Activity */}
                <div className="flex gap-2 sm:gap-6 items-center w-full sm:w-auto">
                  <button
                    onClick={handleOpenPopup}
                    className="bg-primaryBlueBg text-white px-4 sm:px-6 py-3 sm:py-4 rounded-full font-medium text-sm sm:text-base w-full sm:w-auto"
                  >
                    Post Activity
                  </button>
                </div>
              </div>
              {activeTab === "activities" && (
                <>
                  {activityData?.length > 0 ? (
                    <>
                      {activityData?.map((item, index) => (
                        <div
                          key={index}
                          className="bg-white rounded-[13px] border-[1px] border-borderColors p-3.5"
                        >
                          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
                            <div className="flex-1">
                              <p className="font-semibold text-capitalize text-sm sm:text-base">
                                {item?.activity}
                              </p>
                              <p className="text-gray-500 text-xs sm:text-sm">
                                {getDateTime(item?.createdAt)}
                              </p>
                            </div>
                            <div className="text-ambassadorBlue font-semibold text-sm sm:text-base">
                              {item?.pointsEarned || 0} pts
                            </div>
                          </div>
                        </div>
                      ))}

                      {/* Show More Button */}
                      {activityData.length > 10 && hasMoreActivities && (
                        <div className="text-center mt-4">
                          <button
                            className="bg-primaryBlueBg text-white px-6 py-2 rounded-full font-medium"
                            onClick={handleShowMore}
                          >
                            Show More
                          </button>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="bg-white rounded-[13px] border-[1px] border-borderColors p-8 text-center">
                      <p className="text-gray-500 text-sm sm:text-base">
                        No activities found. Start posting activities to see them here!
                      </p>
                    </div>
                  )}
                </>
              )}
              {activeTab === "promotions" && (
                <div className="space-y-4">
                  {promotionsData?.length > 0 ? (
                    <>
                      {promotionsData?.map((promo, index) => {
                        const url = promo.socialMediaLink || "";
                        const platform = url.includes("facebook")
                          ? "Facebook"
                          : url.includes("instagram")
                          ? "Instagram"
                          : url.includes("twitter") || url.includes("x.com")
                          ? "X"
                          : "Other";
                        const platformColorMap: Record<string, string> = {
                          Facebook: "#1877F2",
                          Instagram: "#C13584",
                          X: "#000000",
                          Other: "#A5A5A5",
                        };
                        const Icon =
                          platform === "Facebook"
                            ? FaFacebookF
                            : platform === "Instagram"
                            ? FaInstagram
                            : platform === "X"
                            ? FaX
                            : null;
                        return (
                          <div
                            key={index}
                            className="bg-white rounded-[13px] border-[1px] border-borderColors p-3.5 flex flex-col sm:flex-row items-start justify-between gap-4"
                          >
                            <div
                              className={`flex gap-4 w-full ${
                                promo.activity === "posts"
                                  ? "items-start"
                                  : "items-center"
                              }`}
                            >
                              {promo.activity === "posts" ? (
                                <img
                                  src={userProfilePic}
                                  alt="User"
                                  className="w-10 h-10 rounded-full object-cover"
                                />
                              ) : (
                                <div
                                  className="rounded-full p-2 text-white"
                                  style={{
                                    backgroundColor: platformColorMap[platform],
                                  }}
                                >
                                  {Icon && <Icon />}
                                </div>
                              )}
                              <div className="flex flex-col w-full">
                                {promo.activity === "shares" ? (
                                  <a
                                    href={promo?.socialMediaLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-sm text-blue-600 break-all"
                                  >
                                    {promo?.socialMediaLink}
                                  </a>
                                ) : (
                                  <div className="space-y-2">
                                    {/* Caption */}
                                    <p className="text-sm font-medium">
                                      {promo?.post?.caption}
                                    </p>

                                    {/* Images */}
                                    <div
                                      className={`grid gap-2 ${
                                        promo?.post?.postMedia?.length === 1
                                          ? "grid-cols-1"
                                          : promo?.post?.postMedia?.length === 2
                                          ? "grid-cols-1 sm:grid-cols-2"
                                          : "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4"
                                      }`}
                                    >
                                      {promo?.post?.postMedia?.map(
                                        (mediaObj, i) => (
                                          <img
                                            key={i}
                                            src={concatPathWithBackendUrl(
                                              mediaObj.media.name
                                            )}
                                            alt="post"
                                            className="rounded-lg object-cover w-full 
                                         h-[250px] sm:h-[300px] md:h-[331px] lg:h-[331px]"
                                          />
                                        )
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            <span className="text-xs text-gray-500 whitespace-nowrap self-start sm:self-auto">
                              {new Date(promo.createdAt).toLocaleDateString()}
                            </span>
                          </div>
                        );
                      })}

                      {promotionsData.length > 10 && hasMorePromotions && (
                        <div className="text-center mt-4">
                          <button
                            className="bg-primaryBlueBg text-white px-6 py-2 rounded-full font-medium"
                            onClick={handleShowMorePromotions}
                          >
                            Show More
                          </button>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="bg-white rounded-[13px] border-[1px] border-borderColors p-8 text-center">
                      <p className="text-gray-500 text-sm sm:text-base">
                        No promotions found. Share and post content to see your promotions here!
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <FilterDrawer
        isOpen={drawerOpen}
        onClose={toggleDrawer}
        onApply={onApplyDrawerFilters}
      />
      {/* {open && <DrawerAmbassadorRole isOpen={open} onClose={toggleDrawer} />} */}
      <PostActivityPopup
        isOpen={open}
        onClose={handleClosePopup}
        handleConfirm={handleRedeem}
      />
    </div>
  );
};

export default AmbassadorFamilyprofile;
